export enum Cron {
  Empty = 1,
}

export const cronString = (): Record<Cron, string> => ({
  [Cron.Empty]: '0 0 0 0 0',
})
